import { Box } from '@chakra-ui/react/box'
import { GameProvider } from '@gp/base'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'

import { customerStore } from '@/store/CustomerStore'
import { FetchState } from '@/types/enum'
import { getTenant } from '@/utils/getTenant'

import { ActivationOverlay } from './components/ActivationOverlay'
import { Content } from './components/Content'
import { Header } from './components/Header'
import { esumStore } from './esumStore'
import classes from './styles.module.css'

const TENANT = getTenant()

export const Esum = observer(() => {
  useEffect(() => {
    const initializeData = async () => {
      await customerStore.getAccessToken()
      if (customerStore.accessTokenState === FetchState.fulfilled) {
        esumStore.fetchOffer()
      }
    }
    initializeData()
  }, [])

  return (
    <GameProvider tenant={TENANT} name="esum">
      <Box className={classes.page} as="main">
        <Box aria-hidden={esumStore.isActivating}>
          {!esumStore.isLoading && <Header />}
          <Content />
        </Box>
        {esumStore.isActivating && <ActivationOverlay />}
      </Box>
    </GameProvider>
  )
})
